import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GitGuardianMappingForm from './GitGuardianMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function GitGuardianCredentialsForm(props, ref) {
    const fields = useMemo(() => (
    [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules: [urlRegexValidator],
    },
    {
        name: "token",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true
    }]
    ),[])

    return (
        <GenericPullCredentialsForm
            {...props}
            toolDisplayName={"GitGuardian"}
            ref={ref}
            fields={fields}
            MappingForm={GitGuardianMappingForm}
            initialValue={{ apiEndpoint: "https://api.gitguardian.com"}}
        />
    )
}

export default forwardRef(GitGuardianCredentialsForm);